import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, SelectInput } from '@hb/coffee';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { CONTACT_SPOUSE_RELATION_CODE } from '@/views_v2/verify-credit/types';
import { ContactsGroupContext, SupplementInfoField } from '@/components/supplement-info-fields/types';
import { isEmptyFieldValue } from '@/components/supplement-info-fields/utils';
import type { UserVo } from '@/vo/user';

import styles from './index.module.scss';

@Component({ name: 'ContactRelation' })
export default class ContactRelation extends Vue implements SupplementInfoField {
  @Prop()
  private value!: string | null;

  @Prop(Array) readonly contextOtherContacts!: ContactsGroupContext;

  /** 不能选择配偶 */
  @Prop(Boolean) readonly disableSelectSpouse!: boolean;

  /** 锁定不可变更关系 */
  @Prop(Boolean) readonly lockSelectedSpouse!: boolean;

  private contactRelation: number | null = null;

  private originOptions: OptionItem[] = [];

  private errorMsg = '';

  private async created() {
    this.correctUpdateContactRelation(this.value);

    this.originOptions = await DictApi.getContactRelations();
  }

  private get contactRelationOptions() {
    let lastOptions = this.originOptions;

    if (this.disableSelectSpouse) {
      /** 不可选择配偶，则直接删除关系“配偶”option */
      lastOptions = this.originOptions.filter((it) => it.code !== CONTACT_SPOUSE_RELATION_CODE);
    }

    return lastOptions;
  }

  /** 纠正从外部传入的值-更新联系人关系，确保最终值符合预期 */
  public correctUpdateContactRelation(val: number | string | null): void {
    if (this.lockSelectedSpouse && Number(val) !== CONTACT_SPOUSE_RELATION_CODE) {
      /** 若锁定选择配偶，则修正传入值为配偶 */
      this.contactRelation = CONTACT_SPOUSE_RELATION_CODE;
      /** 修正最后值 同步到 调用父组件 */
      this.$emit('change', CONTACT_SPOUSE_RELATION_CODE);
    } else if (this.disableSelectSpouse && Number(val) === CONTACT_SPOUSE_RELATION_CODE) {
      /** 若不可选择配偶，则修正传入值为null && 错误提示 */
      this.errorMsg = '请重新选择联系人关系';
      this.contactRelation = null;
      /** 修正最后值 同步到 调用父组件 */
      this.$emit('change', null);
    } else {
      this.contactRelation = isEmptyFieldValue(val) ? null : Number(val);
    }
  }

  @Watch('value')
  private onPropsValueChange(val: number | string | null) {
    this.correctUpdateContactRelation(val);
  }

  @Watch('disableSelectSpouse')
  private onPropsDisableSelectSpouseChange() {
    this.correctUpdateContactRelation(this.value);
  }

  // 多联系人时，配偶仅可填写1位
  private checkGroupSpouseRepeate(): boolean {
    if (
      Array.isArray(this.contextOtherContacts)
      && this.contextOtherContacts.some(
        (item: UserVo.ContactInfo) => item.contactRelation === CONTACT_SPOUSE_RELATION_CODE,
      )) {
      const relationList = [
        ...this.contextOtherContacts.map((item: UserVo.ContactInfo) => item.contactRelation),
        this.contactRelation,
      ];

      if (relationList.filter((item) => item === CONTACT_SPOUSE_RELATION_CODE).length > 1) {
        return false;
      }
    }

    this.errorMsg = '';
    return true;
  }


  public onValidator(): boolean {
    if (isEmptyFieldValue(this.contactRelation)) {
      this.errorMsg = '请选择您与联系人的关系';
      return false;
    }

    if (!this.checkGroupSpouseRepeate()) {
      this.errorMsg = '配偶仅可填写1位';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private onChange(val: string | undefined | null | number) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  /** 关系禁止变更：当锁定配偶不可变更 && 已选择配偶关系 */
  private get fieldDisabled(): boolean {
    return this.lockSelectedSpouse && this.contactRelation === CONTACT_SPOUSE_RELATION_CODE;
  }

  private render() {
    return (
      <Field
        label="关系"
        errorMessage={this.errorMsg}
        class={styles.contactRelation}
      >
        <SelectInput
          v-model={this.contactRelation}
          title="选择关系"
          placeholder="选择关系"
          options={this.contactRelationOptions}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          disabled={this.fieldDisabled}
          onChange={this.onChange}
        />
      </Field>
    );
  }
}
